import styled from "styled-components";

const StyledButton = styled.button(({ theme, width, disabled, isMobile, buttonStyle }) => ({
  color: disabled
    ? theme.color.white
    : buttonStyle !== "secondary"
      ? theme.color.white
      : theme.color.red,
  fontSize: isMobile ? 14 : 21.73,
  fontWeight: 700,
  letterSpacing: 0.1,
  padding: 15,
  background: disabled
    ? theme.color.gray
    : buttonStyle !== "secondary"
      ? theme.color.red
      : theme.color.white,
  cursor: disabled ? "default" : "pointer",
  border: disabled ? 0 : buttonStyle !== "secondary" ? 0 : `solid 1px ${theme.color.red}`,
  width: width ? width : "100%",
  borderRadius: 5.1,
  textTransform: "capitalize",
  fontFamily: "NotoSansHebrew",
}));

const Button = ({ buttonStyle, ...props }) => {
  return <StyledButton buttonStyle={buttonStyle} {...props} />;
};

export default Button;
